import { FiAlertCircle } from "react-icons/fi"

export default function SectionFieldError({
  messages
}: {
  messages: string[]
}) {
  if (!messages.length) return null

  return (
    <div className="mb-3 flex items-start gap-2 rounded-md border border-orange-200 bg-orange-50 px-3 py-2 text-sm text-orange-800">
      <FiAlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
      <div className="space-y-1">
        {messages.map(message => (
          <p key={message}>{message}</p>
        ))}
      </div>
    </div>
  )
}
